export const sliderSettings = {
  dots: true,
  arrows: false,
  autoplay: true,
  infinite: false,
  swipe: false,
  autoplaySpeed: 4000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  className: 'account-slider'
};

export const sliderData = [
  {
    title: '1. Register with us',
    description: 'Partner with Easiloan under ‘Easiloan Developer Program’ and upload leads',
    imgUrl: '/icons/developers-1.svg'
  },
  {
    title: '2. CRM & Onsite Support',
    description: 'Dedicated RM and CRM team will assist you through the process',
    imgUrl: '/icons/developers-2.svg'
  },
  {
    title: '3. Improve Profitability',
    description: 'Early cashflows. High retention with faster home loans and better control on customers',
    imgUrl: '/icons/developers-3.svg'
  },
  {
    title: '4. Business Multiplier',
    description: 'Benefit through preferred schemes and bank tie-ups',
    imgUrl: '/icons/developers-4.svg'
  }
];
